"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateValueNamesList = void 0;
const types_1 = require("./types");
const value_wrappers_1 = require("../value-wrappers");
const token_utils_1 = require("./token-utils");
const matchers_1 = require("./matchers");
const tokeniser_1 = require("./tokeniser");
// Regular expressions used to match token value-types at the start of the text.
const placeholderMatcher = [
    matchers_1.StringMatcher,
    matchers_1.PlaceholderMatcher,
];
const variableMatcher = [
    matchers_1.VariableMatcher,
];
// Returns true if there's a variable name that doesn't appear
// in the provided list of state keys.
function hasMissingVariable(variableNames, stateKeys) {
    return variableNames.some((v) => !stateKeys.includes(v));
}
function replaceVariablesWithValues(text, state = {}) {
    const variables = text.split(',').map((v) => {
        let tokens = (0, tokeniser_1.getTokens)(v !== null && v !== void 0 ? v : '', placeholderMatcher);
        // if (hasUnknownToken(tokens)) return makeError(`Parse error: "${text}" contains unsupported characters`);
        // const placeholders = getStrippedVariableNames(tokens);
        // if (hasMissingVariable(placeholders, getStateKeys(state))) {
        //   return {
        //     kind: 'error',
        //     value: `Unknown placeholder in expression: ${text}`,
        //   };
        // }
        tokens = (0, tokeniser_1.getTokens)(tokens
            .map((t) => t.type === types_1.TokenType.PLACEHOLDER
            ? (0, token_utils_1.getVariableFromState)((0, token_utils_1.stripSymbols)(t.value), state)
            : t.value).join(''), variableMatcher);
        // const variables = getVariableNames(tokens);
        //
        // if (hasMissingVariableName(variables, getStateKeys(state)))
        //   return makeError(`Unknown variable in expression: ${text}`);
        return tokens.map((t) => t.value).join('');
    });
    const list = variables.map((v) => (0, token_utils_1.getVariableFromState)(v, state));
    return (0, value_wrappers_1.makeValue)(list, variables);
}
function evaluateValueNamesList(items, state) {
    return replaceVariablesWithValues(items, state);
}
exports.evaluateValueNamesList = evaluateValueNamesList;
